import { fromFetch } from 'rxjs/fetch';
import { FleetJwtAuthHeaders } from '../../models/fleet-jwt-auth-headers';
import { requiredHeaders } from '../../models/required-headers';
import { ignoreData } from '../../utils/ignore-data';
import { fleetEnvironment } from './fleet-environment';

export function postVehicleGroupsRoutingProfilesCombinedAssignment(
  vehicleGroupId: number,
  assignmentRoutingProfileIds: number[],
  unassignmentRoutingProfileIds: number[]
) {
  return fromFetch(
    new Request(
      fleetEnvironment.vehicleGroupsRoutingProfilesCombinedAssignmentUrl(
        String(vehicleGroupId)
      ),
      {
        method: 'POST',
        headers: {
          ...requiredHeaders,
          ...new FleetJwtAuthHeaders(),
        },
        body: JSON.stringify({
          assignmentRoutingProfileIds,
          unassignmentRoutingProfileIds,
        }),
      }
    )
  ).pipe(ignoreData());
}
